module.exports = __webpack_public_path__ + "img/logo35.5b49e0dd.png";